import { createApp } from 'vue'
import App from '@/App.vue'
import router from '@/router/router'

import Default from "@/layouts/Default.vue";
import Internal from "@/layouts/Internal.vue";

import store from './store/store';

const app = createApp(App)

app.component('default-layout', Default);
app.component('internal-layout', Internal);
app.use(router)
app.use(store)
app.mount('#app')


